/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HelpTicketGameHealthContext } from './HelpTicketGameHealthContext';
import {
    HelpTicketGameHealthContextFromJSON,
    HelpTicketGameHealthContextFromJSONTyped,
    HelpTicketGameHealthContextToJSON,
    HelpTicketGameHealthContextToJSONTyped,
} from './HelpTicketGameHealthContext';
import type { HelpTicketCompetitionContext } from './HelpTicketCompetitionContext';
import {
    HelpTicketCompetitionContextFromJSON,
    HelpTicketCompetitionContextFromJSONTyped,
    HelpTicketCompetitionContextToJSON,
    HelpTicketCompetitionContextToJSONTyped,
} from './HelpTicketCompetitionContext';

/**
 * 
 * @export
 * @interface HelpTicketContext
 */
export interface HelpTicketContext {
    /**
     * 
     * @type {Array<HelpTicketCompetitionContext>}
     * @memberof HelpTicketContext
     */
    activeCompetitions: Array<HelpTicketCompetitionContext>;
    /**
     * 
     * @type {Array<HelpTicketGameHealthContext>}
     * @memberof HelpTicketContext
     */
    affectedGames: Array<HelpTicketGameHealthContext>;
    /**
     * 
     * @type {boolean}
     * @memberof HelpTicketContext
     */
    hasDegradedScoring: boolean;
}

/**
 * Check if a given object implements the HelpTicketContext interface.
 */
export function instanceOfHelpTicketContext(value: object): value is HelpTicketContext {
    if (!('activeCompetitions' in value) || value['activeCompetitions'] === undefined) return false;
    if (!('affectedGames' in value) || value['affectedGames'] === undefined) return false;
    if (!('hasDegradedScoring' in value) || value['hasDegradedScoring'] === undefined) return false;
    return true;
}

export function HelpTicketContextFromJSON(json: any): HelpTicketContext {
    return HelpTicketContextFromJSONTyped(json, false);
}

export function HelpTicketContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpTicketContext {
    if (json == null) {
        return json;
    }
    return {
        
        'activeCompetitions': ((json['activeCompetitions'] as Array<any>).map(HelpTicketCompetitionContextFromJSON)),
        'affectedGames': ((json['affectedGames'] as Array<any>).map(HelpTicketGameHealthContextFromJSON)),
        'hasDegradedScoring': json['hasDegradedScoring'],
    };
}

export function HelpTicketContextToJSON(json: any): HelpTicketContext {
    return HelpTicketContextToJSONTyped(json, false);
}

export function HelpTicketContextToJSONTyped(value?: HelpTicketContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeCompetitions': ((value['activeCompetitions'] as Array<any>).map(HelpTicketCompetitionContextToJSON)),
        'affectedGames': ((value['affectedGames'] as Array<any>).map(HelpTicketGameHealthContextToJSON)),
        'hasDegradedScoring': value['hasDegradedScoring'],
    };
}

